import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class DiffAggregateService {

  constructor() {}

  addDiffTotals(data: any): any {
    // Only add data if the required rels are included.
    if (_.get(data, 'rel.diffs', false)) {

      // Add summary data to each diff
      data.rel.diffs = _.map(data.rel.diffs, (diff) => {
        diff.added = _.reduce(diff.lines, (carry, line) => {
          if (line.type === 'new') {
            carry++;
          }
          return carry;
        }, 0);

        diff.removed = _.reduce(diff.lines, (carry, line) => {
          if (line.type === 'old') {
            carry++;
          }
          return carry;
        }, 0);
        return diff;
      });

      data.added = _.reduce(data.rel.diffs, (sum, diff) => {
        return sum + diff.added;
      }, 0);

      data.removed = _.reduce(data.rel.diffs, (sum, diff) => {
        return sum + diff.removed;
      }, 0);
    }

    return data;
  }

  addDiffComments(data: any): any {
    // Only add data if the required rels are included.
    if (_.get(data, 'rel.diffs', false) &&
        _.get(data, 'rel.commits', false) &&
        _.get(data, 'rel.comments', false)) {

      // Sort by id to get them in chronological order
      const allComments = _.sortBy(data.rel.comments, 'id');

      allComments.forEach((c) => {
        // For each comment, find the file/line it belongs to.
        const file = _.find(data.rel.diffs, { fileName: c.path });

        if (file) {
          const line = _.find(file.lines, { type: 'new', new: c.line });

          if (line) {
            if (!_.get(line, 'comments', false)) {
              line.comments = [];
            }

            line.comments.push(c);
          } else {
            // If the line doesn't exist, add to the orphans for this file.
            if (!_.get(file, 'orphanComments', false)) {
              file.orphanComments = [];
            }
            file.orphanComments.push(c);
          }
        } else {
          // If the file doesn't exist, add to the orphans for this diff.
          if (!_.get(data, 'orphanComments', false)) {
            data.orphanComments = [];
          }
          data.orphanComments.push(c);
        }
      });
    }

    return data;
  }
}
